import Commercial from "../assets/images/office.jpg"
import Residental from "../assets/images/residential.jpg"
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CleaningServices = () => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <section id="services" className="py-6 lg:py-16 w-full px-[20px] lg:px-20 xl:px-30 2xl:px-40 bg-gray-100">
      <div className="mx-auto">

        {/* Sección Residencial */}
        <div className="flex flex-col md:flex-row items-center mb-8 lg:mb-16">
          {/* Imagen */}
          <div className="md:w-[40%] relative w-full lg:h-[300px]">
            <img
              src={Residental}
              alt="Residencial Cleaning"
              className="w-full h-full object-cover rounded-md 2xl:rounded-2xl shadow-md"
            />
            <span className="absolute top-4 left-4 text-textTitle font-semibold lg:text-[14px] text-[12px]">
              {t("services.you-home")}
            </span>
            <button onClick={()=>history.push("/quote")} className="absolute bottom-4 lg:left-4 left-1/2 transform lg:translate-x-1 -translate-x-1/2 w-[120px] bg-yellow-400 text-black font-semibold py-2 px-4 rounded-lg shadow hover:bg-yellow-500 transition-colors">
            {t("services.button")}
            </button>
          </div>

          {/* Contenido */}
          <div className="md:w-[60%] md:pl-12 text-center md:text-left mt-8 md:mt-0">
            <h3 className="text-[22px] lg:text-[32px] font-bold text-textTitle mb-4">
            {t("services.residental-title")}
            </h3>
            <p className="text-textSubtitle font-medium text-[12px] lg:text-[14px] leading-[24px] 2xl:leading-[28px] text-justify">
            {t("services.residental-description")} 
            </p>
          </div>
        </div>

        {/* Sección Comercial */}
        <div className="flex flex-col md:flex-row-reverse items-center">
          {/* Imagen */}
          <div className="md:w-[40%] relative w-full lg:h-[300px]">
            <img
              src={Commercial}
              alt="Commercial Cleaning"
              className="w-full h-full object-cover rounded-md lg:rounded-2xl shadow-md"
            />
            <span className="absolute top-4 left-4 text-textTitle font-semibold lg:text-lg text-[12px]">
            {t("services.you-home")}
            </span>
            <button onClick={()=>history.push("/quote")} className="absolute bottom-4 lg:right-4 right-1/2 transform lg:-translate-x-1 translate-x-1/2 w-[120px] bg-yellow-400 text-black font-semibold py-2 px-4 rounded-lg shadow hover:bg-yellow-500 transition-colors">
            {t("services.button")}
            </button>
          </div>

          {/* Contenido */}
          <div className="md:w-[60%] md:pr-12 text-center md:text-left mt-8 md:mt-0">
            <h3 className="text-[22px] lg:text-[32px] font-bold text-textTitle mb-4">
            {t("services.commercial-title")}
            </h3>
            <p className="text-textSubtitle font-medium text-[12px] lg:text-[14px] leading-[24px] 2xl:leading-[28px] text-justify">
            {t("services.commercial-description")} 
            </p>
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default CleaningServices;
